module.exports = __webpack_public_path__ + "img/geo-fill.520d84cf.svg";